import React, { Suspense } from "react";
import styled from "styled-components/macro";
import { useImage } from "react-image";

const ImageComponent = ({ imageURLs, className, style }) => {
  return (
    <Suspense
      fallback={
        <StyledPlaceholderImg
          src='emptyImagePlaceholder.png'
          alt=''
          style={style}
        />
      }
    >
      <InnerImageComponent
        imageURLs={imageURLs}
        className={className}
        style={style}
      />
    </Suspense>
  );
};

const InnerImageComponent = ({ imageURLs, className, style }) => {
  const { src, error } = useImage({
    srcList: imageURLs,
    useSuspense: false
  });

  return (
    <img
      className={className}
      style={style}
      src={!error ? src : "emptyImagePlaceholder.png"}
      alt=''
    />
  );
};

const StyledPlaceholderImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

export default ImageComponent;
